import React from "react";

function Footer({ socialMedia }) {
  return (
    <div className='footer'>
      <div className='row'>
        <div className='col-12 col-md-3'>
          <img alt='' src='/assets/images/white/logo.svg' className='footer-logo' />
        </div>

        {/* =================contact ================= */}
        <div className='col-10  col-md-5 py-2 py-md-0'>
          <div className='footer_title'>Contacts</div>
          <div className='footer_contact_item'>
            <div className=''>
              <img alt='' src='/assets/images/white/phone.svg' className='footer-icon' />
            </div>
            {/* <div className='footer_item'>+(20) 1000046940 or 1069269754</div> */}
            <div className='footer_item'>
              <a href={`tel:${socialMedia.phones[0]}`}>{socialMedia.phones[0]}</a> or{" "}
              <a href={`tel:${socialMedia.phones[1]}`}>{socialMedia.phones[1]}</a>
            </div>
          </div>
          <div className='footer_contact_item'>
            <div className=''>
              <img alt='' src='/assets/images/white/email.svg' className='footer-icon' />
            </div>
            {/* <div className='footer_item'>info@banknote-consulting.com</div> */}
            <div className='footer_item'>
              <a href='mailto:info@banknoteconsult.com'>info@banknoteconsult.com</a>
            </div>
          </div>
          <div className='footer_contact_item'>
            <div className=''>
              <img alt='' src='/assets/images/white/location.svg' className='footer-icon' />
            </div>
            {/* <div className='footer_item'>106 Nile, 5th floor, Dokki, Giza, Egypt</div> */}
            <div className='footer_item'>
              <a
                href='https://www.google.com/maps/search/?api=1&query=106+Nile+Street,+Floors+5,+6,+9+%26+10,+Dokki,+Giza,+Egypt'
                target='_blank'
                rel='noopener noreferrer'>
                106 Nile Street, Floors 5, 6, 9 & 10, Dokki, Giza, Egypt
              </a>
            </div>
          </div>
        </div>
        {/* ================= Products ================= */}
        <div className='col-4 col-md-1'>
          <div className='footer_title'>Products</div>
          <div className='footer_contact_item'>
            <div className='footer_item'>Food</div>
          </div>
          <div className='footer_contact_item'>
            <div className='footer_item'>Furniture</div>
          </div>
          <div className='footer_contact_item'>
            <div className='footer_item'>Animals Feed</div>
          </div>
        </div>
        {/* ================= Home ================= */}
        <div className='col-4 col-md-1'>
          <div className='footer_title'>Home</div>
          <div className='footer_contact_item'>
            <div className='footer_item'>About us</div>
          </div>
          <div className='footer_contact_item'>
            <div className='footer_item'>Contact us</div>
          </div>
        </div>
        {/* ================= Help ================= */}
        <div className='col-4 col-md-1'>
          <div className='footer_title'>Help</div>
          <div className='footer_contact_item'>
            <div className='footer_item'>FAQ</div>
          </div>
          <div className='footer_contact_item'>
            <div className='footer_item'>Shipping</div>
          </div>
        </div>
      </div>

      <div className='footer_seprator'></div>

      {/* <div className="row">
        <div className="col-12 footer_social_parent d-flex d-md-none mb-3 justify-content-center">
            <div className="social_footer"><img src={`/assets/images/white/fixed_massanger.svg`} alt="social" /></div>
            <div className="social_footer"><img src={`/assets/images/white/fixed_whatsapp.svg`} alt="social" /></div>
            <div className="social_footer"><img src={`/assets/images/white/fixed_call.svg`} alt="social" /></div>
            <div className="social_footer"><img src={`/assets/images/white/fixed_telegram.svg`} alt="social" /></div>
        </div>
        <div className="col footer_item last-item"> 2025 Banknote. All Rights Reserved</div>
        <div className="col footer_social_parent d-none d-md-flex">
            <div className="social_footer"><img src={`/assets/images/white/fixed_massanger.svg`} alt="social" /></div>
            <div className="social_footer"><img src={`/assets/images/white/fixed_whatsapp.svg`} alt="social" /></div>
            <div className="social_footer"><img src={`/assets/images/white/fixed_call.svg`} alt="social" /></div>
            <div className="social_footer"><img src={`/assets/images/white/fixed_telegram.svg`} alt="social" /></div>
        </div>
        <div className="col footer_item last-item"> Terms of Services <span className='px-1 px-md-3 '></span> Privacy Policy</div>
    </div> */}

      <div className='row'>
        {/* Mobile view */}
        <div className='col-12 footer_social_parent d-flex d-md-none mb-3 justify-content-center'>
          <div className='social_footer'>
            <a
              href={socialMedia.social.find(item => item.type === "messanger")?.link}
              target='_blank'
              rel='noopener noreferrer'>
              <img src={`/assets/images/white/fixed_messanger.svg`} alt='messanger' />
            </a>
          </div>
          <div className='social_footer'>
            <a
              href={socialMedia.social.find(item => item.type === "whatsapp")?.link}
              target='_blank'
              rel='noopener noreferrer'>
              <img src={`/assets/images/white/fixed_whatsapp.svg`} alt='whatsapp' />
            </a>
          </div>
          <div className='social_footer'>
            <a href={`tel:${socialMedia.phones[0]}`}>
              <img src={`/assets/images/white/fixed_call.svg`} alt='call' />
            </a>
          </div>
          <div className='social_footer'>
            <a
              href={socialMedia.social.find(item => item.type === "telegram")?.link}
              target='_blank'
              rel='noopener noreferrer'>
              <img src={`/assets/images/white/fixed_telegram.svg`} alt='telegram' />
            </a>
          </div>
        </div>

        {/* Center text */}
        <div className='col footer_item last-item'>© 2025 Banknote. All Rights Reserved</div>

        {/* Desktop view */}
        <div className='col footer_social_parent d-none d-md-flex'>
          <div className='social_footer'>
            <a
              href={socialMedia.social.find(item => item.type === "messanger")?.link}
              target='_blank'
              rel='noopener noreferrer'>
              <img src={`/assets/images/white/fixed_messanger.svg`} alt='messanger' />
            </a>
          </div>
          <div className='social_footer'>
            <a
              href={socialMedia.social.find(item => item.type === "whatsapp")?.link}
              target='_blank'
              rel='noopener noreferrer'>
              <img src={`/assets/images/white/fixed_whatsapp.svg`} alt='whatsapp' />
            </a>
          </div>
          <div className='social_footer'>
            <a href={`tel:${socialMedia.phones[0]}`}>
              <img src={`/assets/images/white/fixed_call.svg`} alt='call' />
            </a>
          </div>
          <div className='social_footer'>
            <a
              href={socialMedia.social.find(item => item.type === "telegram")?.link}
              target='_blank'
              rel='noopener noreferrer'>
              <img src={`/assets/images/white/fixed_telegram.svg`} alt='telegram' />
            </a>
          </div>
        </div>

        {/* Terms */}
        <div className='col footer_item last-item'>
          Terms of Services <span className='px-1 px-md-3'></span> Privacy Policy
        </div>
      </div>
    </div>
  );
}

export default Footer;
